<template>
  <div class="navbar navbar-expand-md navbar-dark navbar-48 d-flex flex-row align-items-center justify-content-between ml-0 pl-0">
    <div
      class="d-flex justify-content-between align-items-center navbar-brand ml-0 p-0 pl-3"
      style="width: 100%; min-width: 270px; max-width: 270px; height: 48px;"
    >
      <router-link
        to="/backoffice/home"
        class="d-inline-block"
      >
        <img
          :src="$storeIndex.getLogoGlobalSvgAssets('GoChat-logo-sm')"
          alt=""
          class="logo-sm logo-gochat-beta-sm"
        >
        <img
          :src="$storeIndex.getLogoGlobalSvgAssets('GoChat-logo')"
          alt=""
          class="logo-lg logo-gochat-beta"
        >
      </router-link>
      
      <a
        class="icon-toggle-left-menu-admin"
        @click="toggleMenu()"
      >
        <i
          class="fas fa-align-justify"
        />
      </a>
    </div>
    <!-- <input class="form-control form-control-dark w-100" type="text" placeholder="Search" aria-label="Search"> -->
    <ul class="navbar-nav">
      <li class="nav-item dropdown">
        <a
          href="#"
          class="navbar-nav-link dropdown-toggle caret-0 d-flex flex-row align-items-center justify-content-center"
          data-toggle="dropdown"
        >
          <img
            :src="$storeIndex.getLogoGlobalSvgAssets('default-user')"
            @error="errorMerchantImage($event)"
            class="img-chat-receiver"
            contain
            alt=""
          >
          <div class="d-flex flex-column align-items-start justify-content-center ml-2">
            <span class="user-name-navbar">ADMIN</span>
          </div>
          <img
            class="ml-2"
            src="@/assets/global_assets/images/angle-down-regular-9.svg"
          >
        </a>

        <div
          class="dropdown-menu dropdown-menu-right dropdown-content wmin-md-300"
          style="top: 54px;"
        >
          <div
            class="dropdown-content-header d-flex align-items-center justify-space-between"
            style="cursor: pointer;"
            @click="goLogout()"
          >
            <span class="">{{ $t("Log out") }}</span>
            <i class="far fa-sign-out" />
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  methods: {
    toggleMenu() {
      this.$parent.$refs.leftMenu.toggleLeftMenu();
    },
    goLogout() {
      let self = this;
      self.$storeIndex.logoutBackoffice(self, true);
    },
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/backoffice/layout/template/TopMenu.vue